import { change, Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import {
  getPatientDetailsById,
  getPatientMasterData,
  getPatientMasterTags,
  savePatientDetails,
  savePatientTag,
  getPatientProfileDetails,
} from './actions/PatientActions';
import { CommonButton } from '../../components/buttons';
import {
  isValidFileType,
  isValidName,
  isValidNameWithSpace,
  normalizeMobile,
  normalizeSSN,
  renderAutoCompleteSingleSelect,
  renderAutoCompleteSingleSelectLocation,
  renderCheckBox,
  renderDateField,
  renderTextArea,
  renderTextField,
  renderUploadField,
  isInteger,
  renderAutoCompleteScheduling,
  normalizeDecimal, 
} from '../../components/reduxFields';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import history from './../../history';
import moment from 'moment';
// import validate from './validate';
import Alert from 'react-s-alert';
import { MODULE } from './constants/ApiConstants';
import { displayCustomError, base64Encode, showWarningMessage, VIP, AIP, EBP, CBG, FUTURES, TFABA, EBS, showNormalizedRate, STAGINGQA } from '../../actions/utilAction';
import { checkFieldExistence, clearFieldErrorArray } from '../AppConfig/actions';
import _ from 'lodash';

// import Select from 'react-select';
// import { Creatable } from 'react-select';
// import 'react-select/dist/react-select.css';

const validate = (values) => {
  const error = {};

  if (!values.firstName || values.firstName.trim() === '') {
    error.firstName = 'Please enter first name';
  }
  if (!values.emergencyContactOthers || values.emergencyContactOthers.trim() === '') {
    error.emergencyContactOthers = 'Please enter other relationship';
  }
  if (!values.lastName || values.lastName.trim() === '') {
    error.lastName = 'Please enter last name';
  }
  // if (!values.email || values.email.trim() === '') {
  //   error.email = 'Please enter email address';
  // }
  if (!values.locationID) {
    error.locationID = 'Please select location.';
  }
  // if (!values.renderingProviderID) {
  //   error.renderingProviderID = 'Please select rendering clinician provider.';
  // }
  // if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(values.email)) {
  //   error.email = 'Please enter a valid email address';
  // }
  if (values.emergencyContactPhone && values.emergencyContactPhone.length < 14) {
    error.emergencyContactPhone = 'Please enter valid emergency contact phone number';
  }
  if (!values.dob) {
    error.dob = 'Please select date of birth';
  }
  if (values.ssn && values.ssn.trim() !== '' && values.ssn.length !== 11) {
    error.ssn = 'SSN should be 9 digit number';
  }

  // if (!values.mrn || values.mrn.trim() === '') {
  //   error.mrn = 'Please enter client Id';
  // }


  // if (values.secondaryRace) {
  //   if (!Number.isInteger(values.race)) {
  //     error.secondaryRace = 'Please select an option';
  //   }
  // }

  if (!values.gender) {
    error.gender = 'Please select gender';
  } else if (!Number.isInteger(values.gender)) {
    error.gender = 'Incorrect gender';
  }

  // if (!values.icdid) {
  //   error.icdid = 'Please select primary diagnosis';
  // }

  if (!values.userName || values.userName.trim() === '') {
    error.userName = 'Please enter user name';
  } else if (values.userName && values.userName.length < 6) {
    error.userName = 'Please enter more than 5 characters';
  }

  if (values.userName1 && values.userName1.length < 6) {
    error.userName1 = 'Please enter more than 5 characters';
  }

  // field error validate
  if (!values.patientRenderingProviders || !values.patientRenderingProviders.length) {
    error.patientRenderingProviders = { _error: 'At least one therapy name must be selected' };
  } else {
    const therapyArrayErrors = [];
    values.patientRenderingProviders.forEach((obj, index) => {
      const therapyErrors = {};
      if (!obj.therapyId) {
        therapyErrors.therapyId = 'Please select therapy name';
      }
      if (!obj.staffId) {
        therapyErrors.staffId = 'Please select rendering provider';
      }
      if (!obj.icdiD1) {
        therapyErrors.icdiD1 = 'Please select primary diagnosis';
      }
      therapyArrayErrors[index] = therapyErrors;
      return therapyArrayErrors;
    });
    if (therapyArrayErrors.length) {
      error.patientRenderingProviders = therapyArrayErrors;
    }
  }

  return error;
};

const styles = {
  uploadButton: {
    verticalAlign: 'middle',
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
};

const validateEmail = (email) => {
  if (!email || email.trim() === '') {
    return 'Please enter email address';
  } else if (email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(email)) {
    return 'Please enter a valid email address';
  }
};

const validateEmail1 = (email) => {
  if (email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(email)) {
    return 'Please enter a valid email address';
  }
};

const validateSupportCoordinator = (supportCoordinator) => {
  if (!supportCoordinator || supportCoordinator.trim() === '') {
    return 'Please enter support coordinator';
  } 
};

const validateMRN = (mrn) => {
  if (!mrn || mrn.trim() === '') {
    return 'Please enter client id';
  } 
};

const validatePrimaryProvider = (primaryProvider) => {
  if (!primaryProvider || primaryProvider.trim() === '') {
    return 'Please enter primary provider';
  } 
};


const validateStartDate = (startDate) => {
  if (!startDate) {
    return 'Please select start date';
  } 
};

// let w = 1;

class AccountDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patientId: props.patientId ? props.patientId : null,
      patientDiagnosisId: null,
      patientTags: [],
      masterData: null,
      patientdata: null,
      gender: null,
      marital: null,
      dob: null,
      imagePreviewUrl: null,
      file: null,
      validImageError: null,
      patientPreferenceId: null,
      patientHomeCommPreferencesID: null,
      patientOfficeCommPreferencesID: null,
      masterTags: [],
      masterGender: [],
      masterRace: [],
      masterEthnicity: [],
      masterstaff: [],
      masterICD: [],
      masterRelationship: [],
      isTabChangeRequest: false,
      isPortalRequired: false,
      isDataCollectionEnabledForAgency: false,
      startDate: [],
      endDate: [],    
      firstTherapyOfClient: [],    
      selectedTherapyId: null,
      // patientCommPreferences: props.master_data.masterPatientCommPreferences,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.checkPortalRequired = this.checkPortalRequired.bind(this);
    this.onDateChangeForRenderingProvider = this.onDateChangeForRenderingProvider.bind(this);    
    this.handleNewRequestTherapyName = this.handleNewRequestTherapyName.bind(this);    
  }

  /** *******************     Input field exist check        ***********************/
  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.props.patientId ? this.props.patientId : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };
  /** *****   End Input field exist check    **********/

  componentWillMount() {
    // let searchObj = {
    //   filters: { TypeKey: 'ALL_CLIENT,BOTH' },
    // };
    // this.props.getPatientMasterTags(searchObj);
    let masterData = {
      'masterdata': 'MASTERWEEKDAYS,staffavailability,MASTERGENDER,MASTERRACE,MASTERETHNICITY,MASTERSTAFF,MASTERICD,MASTERRELATIONSHIP,MASTERRENDERINGPROVIDER,MASTERRENDERINGPROVIDERINCLUDINGINACTIVE,MASTERTAGSFORPATIENT,MASTERTHERAPY',
    };
    this.props.getPatientMasterData(masterData);
    // this.props.getMasterData();
    if (this.state.patientId) {
      this.props.getPatientDetailsById(this.state.patientId);
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log('nextProps......', nextProps);
    if (this.props.patientId !== nextProps.patientId) {
      this.setState({ patientId: nextProps.patientId }, () => {
        if (this.state.patientId) {
          this.props.getPatientDetailsById(this.state.patientId);
        }
      });
    }
    if (nextProps.masterTags && this.props.masterTags !== nextProps.masterTags) {
      this.setState({
        masterTags: nextProps.masterTags,
      });
    }
    // console.log(nextProps);
    if (nextProps.patientMasterData && this.props.patientMasterData !== nextProps.patientMasterData) {
      let masterData = nextProps.patientMasterData;
      this.setState({
        masterGender: masterData.masterGender,
        masterRace: masterData.masterRace,
        masterEthnicity: masterData.masterEthnicity,
        masterstaff: masterData.staffs,
        masterICD: masterData.masterICD,
        masterRelationship: masterData.masterRelationship,
      });
    }

    if (nextProps.saved_patientDetails && this.props.saved_patientDetails !== nextProps.saved_patientDetails) {
      let patientdata = nextProps.saved_patientDetails.data;
      let patientId = base64Encode(`${patientdata.id}`);
      history.push(`/client/${patientId}`);
      let diagnosisId = null;
      patientId = patientdata.id;
      this.props.getPatientProfileDetails(patientId);
      // if (patientdata && patientdata.patientDiagnosis) {
      //   let diagnosis = patientdata.patientDiagnosis.find((obj) => obj.isPrimary === true);
      //   diagnosisId = diagnosis && diagnosis.id;
      // }
      this.setState({ patientDiagnosisId: diagnosisId, patientId: patientId, dob: patientdata.dob, patientdata: patientdata/* , dob: patientdata.dob */ }, () => {
      });
      if (this.state.isTabChangeRequest) {
        this.setState({ isTabChangeRequest: false });
        this.props.handlePatientTabChange('1');
      }
    }

    if (nextProps.getPatientDetails && nextProps.getPatientDetails !== this.props.getPatientDetails) {
      let patientData = nextProps.getPatientDetails.data;
      // let patientDiagnosis = (patientData.patientDiagnosis || []).find((obj) => obj.isPrimary);
      let patientTags = patientData.patientTags || [];
      this.setState({ patientTags: patientTags, isPortalRequired : patientData.isPortalRequired, isDataCollectionEnabledForAgency : patientData.isDataCollectionEnabledForAgency        
       });
    }

    if (nextProps.patientRenderingProviders  && nextProps.patientRenderingProviders != this.props.patientRenderingProviders) {      
      let startDate = this.state.startDate;
      let endDate = this.state.endDate;      
      (nextProps.patientRenderingProviders || []).forEach((obj, index) => {
          
          if(obj.startDate != undefined)
          {
            _.update(startDate, `[${index}]`, function (n) {
                return moment(obj.startDate).format('MM-DD-YYYY');
            });
          
            this.props.dispatch(change('AccountDetailsForm', `patientRenderingProviders[${index}].startDate`, moment(obj.startDate).format('MM-DD-YYYY') || null));
          }          
          if(obj.endDate != undefined)
          {
            _.update(endDate, `[${index}]`, function (n) {
                return moment(obj.endDate).format('MM-DD-YYYY');
            });

            this.props.dispatch(change('AccountDetailsForm', `patientRenderingProviders[${index}].endDate`, moment(obj.endDate).format('MM-DD-YYYY') || null));
          }
          
      });

      this.setState({ startDate: startDate, endDate: endDate });
   
    }
  }

  handleNewRequest = (input, selected) => {
    input.onChange(selected.value);
  };

  handleNewRequestTherapyName = (input, selectedRecord, i) => {
    input.onChange(selectedRecord.value);

    let selectorPatientRenderingProviders = this.props.selectorPatientRenderingProviders || [];
    let endDate = this.state.endDate;
    let lastIndexOfEndDate = this.state.lastIndexOfEndDate;
    selectorPatientRenderingProviders.forEach((obj, index) => {
      if(obj.therapyId === selectedRecord.value && i !== index)
      {
        lastIndexOfEndDate = index;
      }
    });    

    if(lastIndexOfEndDate >= this.props.selectorPatientRenderingProviders.length -1)
    {
      lastIndexOfEndDate = lastIndexOfEndDate - 1;
    }
    
    this.setState({endDate: endDate, lastIndexOfEndDate: lastIndexOfEndDate, selectedTherapyId: selectedRecord.value},()=>{   
    });
  };

  checkIsBefore = (date1, date2) => {
    return moment(date1).isBefore(date2);  
  }

  checkIsSameOrBefore = (date1, date2) => {
    return moment(date1).isSameOrBefore(date2);  
  }

  handleNewRequestLocation = (input, selected) => {
    if(this.state.patientId) {
      Alert.warning('This change will update the location of all future sessions', {
        position: 'bottom-right',
        effect: 'slide',
        timeout: 5000,
      });
      // Alert.warning('Are you sure you want to change the client location?', {
      //   position: 'bottom-right',
      //   effect: 'slide',
      //   timeout: 10000,
      //   customFields: {
      //     displayComponent: true,
      //     handleButtonClick: this.handleAlertLocationChangeClick,
      //     //id: obj.id,
      //   },
      // });

      // if(this.state.changeLocation)
      // {
      //   console.log('changeLocation.....Yes',this.state.changeLocation )
      //   input.onChange(selected.value);  
      // }
      // else {
      //   console.log('changeLocation.....No',this.state.changeLocation )
      //   console.log('this.props.currentLocationId.....',this.props.currentLocationId)

      //   this.props.dispatch(change('AccountDetailsForm', 'locationID', this.props.currentLocationId));
      //   input.onChange(this.props.currentLocationId);  
      // }
      input.onChange(selected.value);
    }
    else {
      input.onChange(selected.value);
    }    
  };
  // handleAlertLocationChangeClick = (event) => {    
  //   this.setState({
  //     changeLocation: true
  //   },()=>{
  //     Alert.closeAll();
  //   });    
  // }
  

  checkPortalRequired = (e) => {
    if (e.target.checked) {
      this.setState({ isPortalRequired: true });
    } else {
      this.setState({ isPortalRequired: false });
    }
  }

  handleSaveContinue = (formData) => {
    if ((this.props.fieldError_SSN && this.props.fieldError_SSN.length) || (this.props.fieldError_MRN && this.props.fieldError_MRN.length) 
    || (this.props.fieldError_Email && this.props.fieldError_Email.length) || (this.props.fieldError_Username && this.props.fieldError_Username.length) 
    || (this.props.fieldError_Email1 && this.props.fieldError_Email1.length) || (this.props.fieldError_Username1 && this.props.fieldError_Username1.length) 
     || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    this.setState({ isTabChangeRequest: true });
    this.onSubmit(formData);
  };

  onSubmit = (formData) => {
    if ((this.props.fieldError_SSN && this.props.fieldError_SSN.length) || (this.props.fieldError_MRN && this.props.fieldError_MRN.length) 
    || (this.props.fieldError_Email && this.props.fieldError_Email.length) || (this.props.fieldError_Username && this.props.fieldError_Username.length) 
    || (this.props.fieldError_Email1 && this.props.fieldError_Email1.length) || (this.props.fieldError_Username1 && this.props.fieldError_Username1.length) 
     || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    // console.log('formData---', formData)
    if (!formData.optOut) {
      formData['optOut'] = false;
    }
    formData['firstName'] = formData.firstName.trim();
    formData['middleName'] = formData.middleName ? formData.middleName.trim() : '';
    formData['lastName'] = formData.lastName.trim();
    //formData['dob'] = moment(formData.dob).format('YYYY-MM-DD');
    formData['dob'] =moment(formData.dob).format('YYYY-MM-DD') + 'T' + moment(formData.dob).format('HH:mm:ss'),
    formData['PhotoBase64'] = this.state.imagePreviewUrl;
    formData['race'] = formData.race || null;
    formData['secondaryRaceID'] = formData.secondaryRaceID || null;
    formData['supportCoordinator'] = formData.supportCoordinator ? formData.supportCoordinator.trim() : null;    
    formData['serviceCoordinator'] = formData.serviceCoordinator ? formData.serviceCoordinator.trim() : null;    
    formData['eiNumber'] = formData.eiNumber ? formData.eiNumber.trim() : null;    
    formData['cfcNumber'] = formData.cfcNumber ? formData.cfcNumber.trim() : null;        
    formData['targetCaseManager'] = formData.targetCaseManager ? formData.targetCaseManager.trim() : null;    
    formData['advanceCreditAmount'] = formData.advanceCreditAmount ? showNormalizedRate(formData.advanceCreditAmount || 0) : 0;

    let patientTags = [];
    if (this.state.patientId) {
      patientTags = (this.state.patientTags || []).map((Obj) => {
        return { ...Obj, isDeleted: true };
      });
      (formData.tag || []).forEach((tagId) => {
        // update case for patient tags ------
        let tag = patientTags.find((Obj) => Obj.tagID === tagId && Obj.isDeleted);
        if (tag) {
          let index = patientTags.indexOf(tag);
          patientTags[index] = {
            ...tag,
            'isDeleted': false,
          };
        } else {
          patientTags.push({
            'id': 0,
            'patientID': 0,
            'tagID': tagId,
            'isDeleted': false,
          });
        }
      });
      patientTags = patientTags;//.filter((obj) => obj.isDeleted === false);
    }

    formData['patientRenderingProviders'] = (formData.patientRenderingProviders || []).map((obj,index) => {
      return {
        ...obj,
        patientID: this.state.patientId || 0,
        startDate:  obj.startDate ? moment(obj.startDate).isValid() ? (moment(obj.startDate).format('YYYY-MM-DD') + 'T' + moment(obj.startDate).format('HH:mm:ss')) : null : this.state.startDate[index],
        endDate:  obj.endDate ? moment(obj.endDate).isValid() ? (moment(obj.endDate).format('YYYY-MM-DD') + 'T' + moment(obj.endDate).format('HH:mm:ss')) : null : (this.state.endDate[index] || null),
      }
    });

    let postData = {
      ...formData,
      'id': this.state.patientId || 0,
      //'renderingProviderID': null,
      // 'patientDiagnosis': [{
      //   'id': this.state.patientId ? this.state.patientDiagnosisId || 0 : 0,
      //   'patientID': this.state.patientId || 0,
      //   'icdid': formData.icdid,
      //   'isPrimary': true,
      // }],
      'patientTags': patientTags,
    };

    //  console.log('post patient ...', JSON.stringify(postData));
    this.props.savePatientDetails(postData);
  };

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }

  handleNewRequestTag(input, value) {
    input.onChange(value);    
  }

  // One validation function for all file types
  // isValidFileType(fName, fType) {
  //   let extentionLists = {}; // Create an object for all extension lists
  //   let isValidType = false;
  //   extentionLists.video = ['m4v', 'avi', 'mpg', 'mp4'];
  //   extentionLists.image = ['jpg', 'gif', 'bmp', 'png'];
  //   isValidType = extentionLists[fType].indexOf(fName.split('.').pop()) > -1;
  //   return isValidType;
  // }

  _handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    // console.log(file.type);
    if (file) {
      // console.log('Please select a valid image');
      // this.setState({ validImageError: 'only jpeg, jpg, gif, bmp, png image type allowed.' });
      let isValidTypeImage = isValidFileType(file.name, 'image');
      if (!isValidTypeImage) {
        showWarningMessage('The file you are uploading does not appear to be valid.  Please check the file and try again');
      } else {
        Alert.closeAll();
        reader.onloadend = () => {
          this.setState({
            file: file,
            imagePreviewUrl: reader.result,
          });
        };
        reader.readAsDataURL(file);
      }
    }
  }

  handleRemoveImage = (e, type) => {
    // console.log('type----------', type);
    e.preventDefault();
    if (type === 'profile') {
      this.setState({ imagePreviewUrl: '', file: null });
    }
  };

  onDateChangeForRenderingProvider = (input, value, i, type) => {
    input.onChange(moment(value).format());
    if(type === 'FROM DATE')
    {
        let startDate = this.state.startDate;

        _.update(startDate, `[${i}]`, function (n) {
          return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });

        this.setState({ startDate: startDate }, ()=>{                  
          document.getElementsByName(`patientRenderingProviders[${i}].endDate`)[0].focus();  
      });

      let selectorPatientRenderingProviders = this.props.selectorPatientRenderingProviders || [];
      let selectedDateIndex  = i;//this.state.startDate.length - 1;      
      let endDate = this.state.endDate;              
      let endDateOfLastSameActivity  = moment(this.state.startDate[selectedDateIndex]).subtract(1, "days");
      let lastIndexOfEndDate = 0;
      selectorPatientRenderingProviders.forEach((obj, index) => {        
        if(obj.therapyId === selectorPatientRenderingProviders[i].therapyId  && lastIndexOfEndDate !== null && index != selectedDateIndex && index <= selectedDateIndex)
        {      
          lastIndexOfEndDate = index;
        }
      });

      endDate[lastIndexOfEndDate] = this.state.startDate[lastIndexOfEndDate]  != null && endDateOfLastSameActivity > this.state.startDate[lastIndexOfEndDate]  ? this.state.startDate[lastIndexOfEndDate] : endDateOfLastSameActivity;      

      if(lastIndexOfEndDate >= this.props.selectorPatientRenderingProviders.length -1)
      {
        lastIndexOfEndDate = lastIndexOfEndDate - 1;
      }
      if(moment(endDate[lastIndexOfEndDate]).format('MM-DD-YYYY') !== 'Invalid date' && this.checkIsSameOrBefore(moment(endDate[lastIndexOfEndDate]).format('MM-DD-YYYY'), moment(startDate[lastIndexOfEndDate]).format('MM-DD-YYYY'))) {        
        endDate[lastIndexOfEndDate] = moment(startDate[lastIndexOfEndDate]).format('MM-DD-YYYY');
      }
      this.setState({endDate: endDate, selectedTherapyId: null},()=>{                 
        this.props.dispatch(change('AccountDetailsForm', `patientRenderingProviders[${lastIndexOfEndDate}].endDate`,moment(endDate[lastIndexOfEndDate]).format('MM-DD-YYYY') || null));
      });
      
    }
    else if(type === 'TO DATE')
    {
        let endDate = this.state.endDate;

        _.update(endDate, `[${i}]`, function (n) {
          return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });
        
        this.setState({ endDate: endDate }, ()=>{                  
          document.getElementsByName(`patientRenderingProviders[${i}].startDate`)[0].focus();           
      });
    }
  }

  addOneDay = (date) => {    
    date.setDate(date.getDate() + 1);
    return date;
  }


  addRow = () => { };
  removeRow = (i) => { };

  renderTherapies = ({ fields }) => {
    this.removeRow = (index, firstTherapyOfClient, therapyId) => {
      let startDate = this.state.startDate;  
     let startDateWithIndex = this.state.startDate[index];
      for(let j = 0; j < this.state.startDate.length; j++)
      {
          if(startDate[j] === undefined)
          {
            startDate[j] = null;
          }
      }
      fields.remove(index);
      let selectedEndDateValue = this.state.endDate[index];
      this.setState({
        startDate: startDate.filter((_, i) => i !== index),
        endDate: this.state.endDate.filter((_, i) => i !== index)
      },() => {
        if(!firstTherapyOfClient === true && startDateWithIndex != undefined) {
          let endDate = this.state.endDate;
          let startDate = this.state.startDate;        
          let selectorPatientRenderingProviders = this.props.selectorPatientRenderingProviders.filter((_, i) => i !== index) || [];
          let selectedDateIndex  = index;//,indexCount1 = 0;
          let endDateOfPreviousRange  = moment(this.state.startDate[selectedDateIndex]).subtract(1, "days");       
          selectorPatientRenderingProviders.forEach((obj, i) => {   
              let selectedDateIndex  = index - 1;  
              if(selectedDateIndex < 0)
                selectedDateIndex = 0;
                let lastIndexOfEndDate = 0, indexCount = 0;
                  let endDatePrevious = this.state.startDate[i] > endDateOfPreviousRange ? this.state.startDate[i] : endDateOfPreviousRange;
                    selectedDateIndex  = index;//this.state.startDate.length - 1; '
                    let therapyPreviousIndex = 0, therapyNextIndex = 0, flag = true;                     
                    let selectorPatientRenderingProviders = this.props.selectorPatientRenderingProviders || [];                  
                    selectorPatientRenderingProviders.forEach((obj, i) => {        
                            if(obj.therapyId === therapyId)
                            {   
                              if(i < selectedDateIndex)   
                                therapyPreviousIndex = i;
                              else if(i >= selectedDateIndex && flag) {
                                therapyNextIndex = i;
                                flag = false;
                              }  
                              indexCount = indexCount + 1;
                            }
                          if(obj.therapyId === therapyId && i != selectedDateIndex)
                          {      
                            lastIndexOfEndDate = i;
                          }
                        });

                        if(indexCount > 1 && indexCount >= (this.props.selectorPatientRenderingProviders.filter((data, i) => data.therapyId === therapyId)).length ) {
                          if(therapyPreviousIndex >= 0){
                                if(therapyNextIndex === 0) {
                                  endDate[therapyPreviousIndex] = null;
                                }
                                else {
                                  endDate[therapyPreviousIndex] = moment(startDate[therapyNextIndex]).subtract(1, "days");
                                }
                              this.props.dispatch(change('AccountDetailsForm', `patientRenderingProviders[${therapyPreviousIndex}].endDate`, endDate[therapyPreviousIndex]));
                          }
                          else if(selectedDateIndex === lastIndexOfEndDate || (indexCount + 1) === lastIndexOfEndDate || (selectedDateIndex - 1) === lastIndexOfEndDate){
                            endDate[lastIndexOfEndDate] = null;
                            this.props.dispatch(change('AccountDetailsForm', `patientRenderingProviders[${lastIndexOfEndDate}].endDate`, null));
                          }
                          else if(lastIndexOfEndDate < indexCount) {                                
                            endDate[lastIndexOfEndDate] = moment(startDate[selectedDateIndex]).subtract(1, "days");
                          }   
                          else if(startDate[selectedDateIndex - 1] != null && this.checkIsSameOrBefore(moment(endDatePrevious).format('MM-DD-YYYY'), moment(startDate[selectedDateIndex - 1]).format('MM-DD-YYYY'))) {    
                            endDate[selectedDateIndex - 1] = startDate[selectedDateIndex - 1];
                          }                           
                          else {
                            if(endDatePrevious  != undefined && moment(endDatePrevious).format('MM-DD-YYYY') !== 'Invalid date'){
                              endDate[selectedDateIndex - 1] = endDatePrevious;
                            }
                            else {
                              endDate[selectedDateIndex - 1] =  selectedEndDateValue;
                            }
                          }
                          this.props.dispatch(change('AccountDetailsForm', `patientRenderingProviders[${selectedDateIndex - 1}].endDate`, endDate[selectedDateIndex - 1]));
                        } else if(indexCount > 1 && indexCount < (this.props.selectorPatientRenderingProviders.filter((data, i) => data.therapyId === therapyId)).length ){
                          endDate[selectedDateIndex - 1] = null;
                          this.props.dispatch(change('AccountDetailsForm', `patientRenderingProviders[${selectedDateIndex - 1}].endDate`, null));
                        } else {
                          endDate[lastIndexOfEndDate] = null;
                          this.props.dispatch(change('AccountDetailsForm', `patientRenderingProviders[${lastIndexOfEndDate}].endDate`, null));
                        }

                  this.setState({endDate: endDate},()=>{
                    document.getElementsByName(`patientRenderingProviders[${i}].startDate`)[0].focus(); 
                  });
          });
        }
      });
    };

    this.addRow = (e) => {
      fields.push({});
    };

    let startDate = this.state.startDate;
    let endDate = this.state.endDate;
    return (
      <div className="row">
        <div className="col-sm-12">
          <div className="panel_title no_margin">
            <h3>Rendering Providers For Therapy </h3>
            <i className="flaticon flaticon-shield"></i>
            <small className="redfont font12"> (Changes here will not change the rendering provider for rendered/completed sessions. If a session is rendered, then the rendering provider needs to be changed in the billing area.)</small>
          </div>
          {fields.map((therapy, index) => {
              if(this.state.startDate[index] === undefined)
              {   
                _.update(startDate, `[${index}]`, function (n) {
                  return null;
                });          
                this.setState({ startDate: startDate });
              }   
              if(this.state.endDate[index] === undefined)
              {   
                _.update(endDate, `[${index}]`, function (n) {
                  return null;
                });          

                this.setState({ endDate: endDate });
              }              
              let selectorPatientRenderingProviders = this.props.selectorPatientRenderingProviders;              
              let firstTherapyOfClient = [];
              let lastTherapyOfClient = [];
              selectorPatientRenderingProviders && selectorPatientRenderingProviders.forEach((obj, index) => { 
                let indexTherapyId = (lastTherapyOfClient && lastTherapyOfClient.filter((data, i) => data.therapyId === obj.therapyId)[0] && lastTherapyOfClient.filter((data, i) => data.therapyId === obj.therapyId)[0].index ? lastTherapyOfClient.filter((data, i) => data.therapyId === obj.therapyId)[0].index : []);                
                let therapyId = (firstTherapyOfClient && firstTherapyOfClient.filter((data, i) => data.therapyId === obj.therapyId)[0] && firstTherapyOfClient.filter((data, i) => data.therapyId === obj.therapyId)[0].therapyId ? firstTherapyOfClient.filter((data, i) => data.therapyId === obj.therapyId)[0].therapyId : []);                
                if(obj.therapyId !== undefined && obj.therapyId !== therapyId)
                {    
                  
                  let Obj = {
                    'index': index,
                    'therapyId': obj.therapyId,                    
                  }
               
                  firstTherapyOfClient.push(Obj);   


                  let startDate = this.state.startDate;  
                  for(let j = 0; j < this.state.startDate.length; j++)
                  {
                      if(j === indexTherapyId)
                      {
                        startDate[j] = null;
                      }

                      if(j === Obj.index)
                      {
                        startDate[j] = null;
                      }
                  }

                  this.setState({ startDate: startDate },()=>{
                        this.props.dispatch(change('AccountDetailsForm', `patientRenderingProviders[${indexTherapyId}].startDate`, null));
                        this.props.dispatch(change('AccountDetailsForm', `patientRenderingProviders[${Obj.index}].startDate`, null));
                      });
                }

                if(obj.therapyId !== undefined && obj.startDate !== undefined)
                {    
                  
                  let Obj = {
                    'index': index,
                    'therapyId': obj.therapyId,    
                    //'startDate': obj.startDate,       
                    'startDate': moment(obj.startDate).add(1, "days"),       
                             
                  }

                  const index1 = lastTherapyOfClient.findIndex(object => {                    
                      return object.therapyId === Obj.therapyId;
                    });
                
                    if(index1 > -1){
                      lastTherapyOfClient.splice(index1, 1);
                    }

                  lastTherapyOfClient.push(Obj);   
                }
              });       
              
             this.setState({ firstTherapyOfClient: firstTherapyOfClient });
             let therapyId = (this.props.selectorPatientRenderingProviders && this.props.selectorPatientRenderingProviders.filter((_, i) => i === index)[0] ? (this.props.selectorPatientRenderingProviders.filter((_, i) => i === index)[0].therapyId) : null);
            return (
              <div className="row mrgbtm">
                <div className="col-sm-12">
                  <div className="row">
                    <div className="col-sm-2 mt-35 require">
                      <Field
                        name={`patientRenderingProviders[${index}].therapyId`}                        
                        label="Therapy Name"                        
                        handleNewRequest={(input, selectedRecord) => this.handleNewRequestTherapyName(input, selectedRecord, index)}
                        options={this.props.masterTherapy}
                        disabled={this.state.startDate[index] ? true : false}
                        component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-2 mt-35 require">
                      <Field
                        name={`patientRenderingProviders[${index}].staffId`}
                        label="Rendering Provider"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.RenderingProviders}
                        component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-2">
                      <Field
                        name={`patientRenderingProviders[${index}].referringProviderFirstName`}
                        type="text"
                        maxLength="250"
                        normalize={isValidNameWithSpace}
                        label="Referring Provider First Name"
                        component={renderTextField} />
                    </div>
                    <div className="col-sm-2">
                      <Field
                        name={`patientRenderingProviders[${index}].referringProviderLastName`}
                        type="text"
                        maxLength="250"
                        normalize={isValidNameWithSpace}
                        label="Referring Provider Last Name"
                        component={renderTextField} />
                    </div>
                    <div className="col-sm-2">                  
                        <Field
                          name={`patientRenderingProviders[${index}].referringProviderNPINumber`}
                          label="Referring Provider NPI"
                          maxLength='10'
                          component={renderTextField}
                          normalize={isInteger}
                        />
                    </div>
                    <div className="col-sm-2">
                      <Field
                          name={`patientRenderingProviders[${index}].referringProviderTaxonomyCode`}                          
                          type="text"
                          maxLength='100'
                          label="Referring Provider Code (BOX 17A)"                    
                          component={renderTextField} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-2 mt-35 require">
                        <Field
                            name={`patientRenderingProviders[${index}].icdiD1`}
                            label="Primary Diagnosis"
                            handleNewRequest={this.handleNewRequest}
                            options={this.state.masterICD}
                            component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-2 mt-35">
                        <Field
                          name={`patientRenderingProviders[${index}].icdiD2`}
                          label="Diagnosis code 2"
                          handleNewRequest={this.handleNewRequest}
                          options={this.state.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-2 mt-35">
                        <Field
                          name={`patientRenderingProviders[${index}].icdiD3`}
                          label="Diagnosis code 3"
                          handleNewRequest={this.handleNewRequest}
                          options={this.state.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-2 mt-35">
                        <Field
                          name={`patientRenderingProviders[${index}].icdiD4`}
                          label="Diagnosis code 4"
                          handleNewRequest={this.handleNewRequest}
                          options={this.state.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-2">
                          <Field
                            name={`patientRenderingProviders[${index}].startDate`}
                            placeholder="From Date"
                            locale="en-US"
                            //minDate={lastTherapyOfClient.filter((data, i) => data.therapyId === this.state.selectedTherapyId).length > 0 ? lastTherapyOfClient.filter((data, i) => data.therapyId === this.state.selectedTherapyId)[0].startDate : new Date(1900, 9, 11)}
                            //minDate={(this.state.startDate[index - 1] !== undefined && this.state.startDate[index - 1] !== null ? (this.addOneDay(new Date(this.state.startDate[index - 1]))) : (this.state.endDate[index - 1] !== undefined && this.state.endDate[index - 1] !== null ? (this.addOneDay(new Date(this.state.endDate[index - 1]))) : new Date(1900, 9, 11)))}
                            minDate={this.props.selectorPatientRenderingProviders && this.props.selectorPatientRenderingProviders.filter((_, i) => i === (index - 1)) && this.props.selectorPatientRenderingProviders.filter((_, i) => i === (index - 1))[0] && this.props.selectorPatientRenderingProviders.filter((_, i) => i === (index - 1))[0].startDate !== undefined && this.props.selectorPatientRenderingProviders.filter((_, i) => i === (index - 1))[0].startDate !== null   ?  (this.state.lastIndexOfEndDate !== null && this.props.selectorPatientRenderingProviders && this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0] && this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0].startDate != null  ? (this.addOneDay(new Date(this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0].startDate))) : (this.state.lastIndexOfEndDate !== null && this.props.selectorPatientRenderingProviders && this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0] && this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0].endDate != null  ? (this.addOneDay(new Date(this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0].endDate))) : new Date(1900, 9, 11))) : new Date(1900, 9, 11)}
                            //// minDate={this.state.lastIndexOfEndDate !== null && this.props.selectorPatientRenderingProviders && this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0] && this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0].startDate != null  ? (this.addOneDay(new Date(this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0].startDate))) : (this.state.lastIndexOfEndDate !== null && this.props.selectorPatientRenderingProviders && this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0] && this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0].endDate != null  ? (this.addOneDay(new Date(this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0].endDate))) : new Date(1900, 9, 11))}
                            //minDate={((therapyId != null && this.props.selectorPatientRenderingProviders && this.props.selectorPatientRenderingProviders.filter((data, i) => data.therapyId === therapyId && i === (index - 1))[0] && this.props.selectorPatientRenderingProviders.filter((data, i) => data.therapyId === therapyId && i === (index - 1))[0].startDate != undefined && this.props.selectorPatientRenderingProviders.filter((data, i) => data.therapyId === therapyId && i === (index - 1))[0].startDate !== null ? this.addOneDay(new Date(this.props.selectorPatientRenderingProviders.filter((data, i) => data.therapyId === therapyId && i === (index - 1))[0].startDate)) : (therapyId !== null && this.props.selectorPatientRenderingProviders && this.props.selectorPatientRenderingProviders.filter((data, i) => data.therapyId === therapyId && i === (index - 1))[0] && this.props.selectorPatientRenderingProviders.filter((data, i) => data.therapyId === therapyId && i === (index - 1))[0].endDate !== undefined && this.props.selectorPatientRenderingProviders.filter((data, i) => data.therapyId === therapyId && i === (index - 1))[0].endDate !== null ? this.addOneDay(new Date(this.props.selectorPatientRenderingProviders.filter((data, i) => data.therapyId === therapyId && i === (index - 1))[0].endDate)) :  this.state.lastIndexOfEndDate !== null ? this.addOneDay(new Date(this.props.selectorPatientRenderingProviders.filter((_, i) => i === this.state.lastIndexOfEndDate)[0].startDate)) : new Date(1900, 9, 11))) )}
                            
                            maxDate={this.state.endDate[index] ? this.state.endDate[index] : new Date(2120, 9, 11)}
                            selected={this.state.startDate[index] || null}        
                           // disabled={firstTherapyOfClient.filter((data, i) => data.index === index).length > 0 ? true : (this.state.selectedTherapyId > 0 || this.state.startDate[index]) ? false : true}
                           disabled={firstTherapyOfClient.filter((data, i) => data.index === index).length > 0 ? true : false}
                            onDateChange={(input, value) => this.onDateChangeForRenderingProvider(input, value, index, 'FROM DATE')}
                            openToYearSelection={true}
                            validate={firstTherapyOfClient.filter((data, i) => data.index === index).length > 0 ? null : [validateStartDate]}
                            component={renderDateField} />
                    </div>
                    <div className="col-sm-2">
                          <Field
                            name={`patientRenderingProviders[${index}].endDate`}
                            placeholder="To Date"
                            locale="en-US"
                            minDate={this.state.startDate[index] || new Date()}
                            selected={this.state.endDate[index] || null}
                            disabled={true}
                            onDateChange={(input, value) => this.onDateChangeForRenderingProvider(input, value, index, 'TO DATE')}
                            openToYearSelection={true}
                            component={renderDateField} />

                      {fields.length === index + 1 ?
                        <div>
                          {fields.length > 1 ?
                            <button className="removeitem"
                              onClick={this.removeRow.bind(this, index, (firstTherapyOfClient.filter((data, i) => data.index === index).length > 0 ? true : false), therapyId)}
                              title="Remove Therapy"
                              type="button">
                              <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                            </button>
                            : ''}
                          <button className="additem" title="Add Therapy" onClick={(e) => this.addRow()} type="button">
                            <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                          </button>
                        </div>
                        :
                        <div>
                          <button className="removeitem"
                            onClick={this.removeRow.bind(this, index, (firstTherapyOfClient.filter((data, i) => data.index === index).length > 0 ? true : false), therapyId)}
                            title="Remove Therapy"
                            type="button">
                            <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            );
          })
          }
        </div>
      </div>
    );
  };


  renderTherapiesDiagnosisYear = ({ fields }) => {
    this.removeRow = (i, e) => {
      fields.remove(i);
    };

    this.addRow = (e) => {
      fields.push({});
    };

    return (
      <div className="row">
        <div className="col-sm-12">
          <div className="panel_title no_margin">
            <h3>Rendering Providers For Therapy</h3>
            <i className="flaticon flaticon-shield"></i>
          </div>
          {fields.map((therapy, index) => {
            let restSelectors = (this.props.selectorPatientRenderingProviders || []).filter((obj, pIndex) => pIndex !== index),
            dropdownFilteredTherapies = _.differenceWith(this.props.masterTherapy, restSelectors, function (o1, o2) {
              return (o2['therapyId'] === o1['id']);
            });
            return (
              <div className="row">
                <div className="col-sm-12">
                  <div className="row">
                    <div className="col-sm-3 mt-35 require">
                      <Field
                        name={`${therapy}.therapyId`}
                        label="Therapy Name"
                        handleNewRequest={this.handleNewRequest}
                        options={dropdownFilteredTherapies}
                        component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-3 mt-35 require">
                      <Field
                        name={`${therapy}.staffId`}
                        label="Rendering Provider"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.RenderingProviders}
                        component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-2">
                      <Field
                        name={`${therapy}.referringProviderFirstName`}
                        type="text"
                        maxLength="250"
                        normalize={isValidNameWithSpace}
                        label="Referring Provider First Name"
                        component={renderTextField} />
                    </div>
                    <div className="col-sm-2">
                      <Field
                        name={`${therapy}.referringProviderLastName`}
                        type="text"
                        maxLength="250"
                        normalize={isValidNameWithSpace}
                        label="Referring Provider Last Name"
                        component={renderTextField} />
                    </div>
                    <div className="col-sm-2">                  
                        <Field
                          name={`${therapy}.referringProviderNPINumber`}
                          label="Referring Provider NPI"
                          maxLength='10'
                          component={renderTextField}
                          normalize={isInteger}
                        />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <Field
                          name={`${therapy}.referringProviderTaxonomyCode`}                          
                          type="text"
                          maxLength='100'
                          label="Referring Provider Taxonomy Code"                    
                          component={renderTextField} />
                    </div>
                    <div className="col-sm-3 mt-35 require">
                        <Field
                            name={`${therapy}.icdiD1`}
                            label="Primary Diagnosis"
                            handleNewRequest={this.handleNewRequest}
                            options={this.state.masterICD}
                            component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-2 mt-35">
                        <Field
                          name={`${therapy}.icdiD2`}
                          label="Diagnosis code 2"
                          handleNewRequest={this.handleNewRequest}
                          options={this.state.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-2 mt-35">
                        <Field
                          name={`${therapy}.icdiD3`}
                          label="Diagnosis code 3"
                          handleNewRequest={this.handleNewRequest}
                          options={this.state.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-2 mt-35">
                        <Field
                          name={`${therapy}.icdiD4`}
                          label="Diagnosis code 4"
                          handleNewRequest={this.handleNewRequest}
                          options={this.state.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                   </div>
                  </div>
                  <div className="row">
                   <div className="col-sm-3">
                        <Field
                            name={`${therapy}.icD1DiagnosedYear`}
                            label="Primary Diagnosis Year"
                            maxLength='4'
                            component={renderTextField} />
                    </div>
                    <div className="col-sm-3">
                        <Field
                          name={`${therapy}.icD2DiagnosedYear`}
                          label="Diagnosis code 2 Year"
                          maxLength='4'
                          component={renderTextField} />
                    </div>
                    <div className="col-sm-3">
                        <Field
                          name={`${therapy}.icD3DiagnosedYear`}
                          label="Diagnosis code 3 Year"
                          maxLength='4'
                          component={renderTextField}  />
                    </div>
                    <div className="col-sm-3">
                        <Field
                          name={`${therapy}.icD4DiagnosedYear`}
                          label="Diagnosis code 4 Year"
                          maxLength='4'
                          component={renderTextField}  />
                    </div>
                   </div>
                   <div className="row">                    
                    <div className="col-sm-3 mt-35">
                        <Field
                            name={`${therapy}.medicalICDID1`}
                            label="Medical Dx Code 1"
                            handleNewRequest={this.handleNewRequest}
                            options={this.state.masterICD}
                            component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-3 mt-35">
                        <Field
                          name={`${therapy}.medicalICDID2`}
                          label="Medical Dx Code 2"
                          handleNewRequest={this.handleNewRequest}
                          options={this.state.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-3 mt-35">
                        <Field
                          name={`${therapy}.medicalICDID3`}
                          label="Medical Dx Code 3"
                          handleNewRequest={this.handleNewRequest}
                          options={this.state.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-3 mt-35">
                        <Field
                          name={`${therapy}.medicalICDID4`}
                          label="Medical Dx Code 4"
                          handleNewRequest={this.handleNewRequest}
                          options={this.state.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                   
                      {fields.length === index + 1 ?
                        <div>
                          {fields.length > 1 ?
                            <button className="removeitem"
                              onClick={this.removeRow.bind(this, index)}
                              title="Remove Therapy"
                              type="button">
                              <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                            </button>
                            : ''}
                          <button className="additem" title="Add Therapy" onClick={(e) => this.addRow()} type="button">
                            <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                          </button>
                        </div>
                        :
                        <div>
                          <button className="removeitem"
                            onClick={this.removeRow.bind(this, index)}
                            title="Remove Therapy"
                            type="button">
                            <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            );
          })
          }
        </div>
      </div>
    );
  };


  render() {
    let relationshipTypeObj = {};
    if (this.props.EmergencyContactRelationship && this.props.patientMasterData && this.props.patientMasterData.masterRelationship) {
      this.props.patientMasterData.masterRelationship.map((masterObj, masterIndex) => {
        if (this.props.EmergencyContactRelationship === masterObj.id) {
          relationshipTypeObj = masterObj;
        }
        return relationshipTypeObj;
      });
    }
    const { handleSubmit } = this.props;
    return (
      <div>
        <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>
          <div className="readmin-panel">
            <div className="panel-body">

              <div className="row">
                <div className="col-sm-4 require">
                  <Field
                    autoFocus={true}
                    name="firstName"
                    type="text"
                    maxLength="40"
                    normalize={isValidNameWithSpace}
                    label="First Name"
                    component={renderTextField} />
                </div>
                <div className="col-sm-4">
                  <Field
                    name="middleName"
                    type="text"
                    maxLength="40"
                    normalize={isValidNameWithSpace}
                    label="Middle Name"
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="lastName"
                    type="text"
                    maxLength="40"
                    normalize={isValidNameWithSpace}
                    label="Last Name"
                    component={renderTextField} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4 require mt-35 customselect">
                  <Field
                    name="gender"
                    label="Gender"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.masterGender}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="dob"
                    placeholder="Date of Birth"
                    component={renderDateField}
                    locale="en-US"
                    openToYearSelection={true}
                    maxDate={new Date()}
                    selected={this.props.dob ? this.props.dob : this.state.dob}
                    onDateChange={this.onDateChange} />
                </div>
                <div className="col-sm-4">
                  <Field
                    name="ssn"
                    type="text"
                    maxLength="11"
                    label="SSN"
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'SSN')}
                    customError={displayCustomError('SSN', this.props.fieldError_SSN)}
                    component={renderTextField}
                    normalize={normalizeSSN} />
                </div>
              </div>
              <div className="row">                
                <div className={this.props.agencyName.toUpperCase() === FUTURES ? 'col-sm-4 require' : 'col-sm-4'} >
                  <Field
                    name="mrn"
                    type="text"
                    maxLength="50"
                    label="Client ID"
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'MRN')}
                    customError={displayCustomError('MRN', this.props.fieldError_MRN)}
                    component={renderTextField}
                    validate={this.props.agencyName.toUpperCase() === FUTURES ? validateMRN : null}
                    normalize={isValidNameWithSpace} />
                </div>
                <div className="col-sm-4 mt-35">
                  <Field
                    name="race"
                    label="Race"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.masterRace}
                    component={renderAutoCompleteSingleSelect} />

                </div>
                <div className="col-sm-4 mt-35">
                  <Field
                    name="secondaryRaceID"
                    label="Secondary Race"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.masterRace}
                    component={renderAutoCompleteSingleSelect} />
                </div>
              </div>
              <div className="row">                
                <div className="col-sm-4 mt-35">
                  <Field
                    name="ethnicity"
                    label="Ethnicity"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.masterEthnicity}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className={this.props.agencyName.toUpperCase() === FUTURES ? 'col-sm-4 require' : 'col-sm-4'} >
                  {/* <Field
                name="PrimaryProvider"
                label="Primary Provider"
                handleNewRequest={this.handleNewRequest}
                options={this.state.masterstaff}
                component={renderAutoCompleteSingleSelect}/> */}
                  <Field
                    name="primaryProvider"
                    type="text"
                    maxLength="40"
                    normalize={isValidNameWithSpace}
                    label="Primary Provider"
                    validate={this.props.agencyName.toUpperCase() === FUTURES ? validatePrimaryProvider : null}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require mt-35">
                  <Field
                    name="locationID"
                    label="Location"
                    handleNewRequest={this.handleNewRequestLocation}
                    disabled={this.state.patientId ? this.props.changeClientLocation ? false : true : false}
                    options={this.props.userLocationList}
                    component={renderAutoCompleteSingleSelectLocation} />
                </div>
              </div>
              <div className="row">
                {/*<div className="col-sm-4">
                  <Field
                    name="referringProvider"
                    type="text"
                    maxLength="40"
                    normalize={isValidNameWithSpace}
                    label="Referring Provider"
                    component={renderTextField} />
                </div>
                 <div className="col-sm-4">
                            <Field
                                name="ClientID"
                                label="ClientID"
                                type="text"
                                component={renderTextField}/>
                        </div>
                <div className="col-sm-4">                  
                    <Field
                      name="referringProviderNPINumber"
                      label="Referring Provider NPI Number"
                      maxLength='10'
                      component={renderTextField}
                      normalize={isInteger}
                    />
                </div>*/}               
               <div className="col-sm-4 optout">
                  <div className={this.state.isPortalRequired ? 'require emailfield' : 'emailfield'}>
                    <Field
                      name="email"
                      type="text"
                      maxLength="60"
                      label="Email"
                      onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Email')}
                      customError={displayCustomError('EMAIL', this.props.fieldError_Email)}
                      validate={this.state.isPortalRequired ? validateEmail : null}
                      component={renderTextField} />
                  </div>
                  <div className="optoutitem">
                    <Field
                      name="optOut"
                      label="Opt Out"
                      component={renderCheckBox} />
                  </div>
                </div>                
                <div className="col-sm-4 require">
                  <Field
                    name="userName"
                    type="text"
                    maxLength="60"
                    autoComplete='email'
                    disabled={this.props.patientId && this.props.editUsernamePermission === false  ? true : false}
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Username')}
                    customError={displayCustomError('USERNAME', this.props.fieldError_Username)}
                    normalize={isValidName}
                    label="User Name"
                    component={renderTextField} />
                </div>
                <div className="col-sm-4">
                  <Field
                    className="mt-35 mb0 rend-check"
                    name="isPortalRequired"
                    label="Portal Required"
                    component={renderCheckBox}
                    onChange={(e) => this.checkPortalRequired(e)}
                  />
                </div>
              </div>                
              <div className="row">
                <div className="col-sm-4">
                    <div className='emailfield'>
                      <Field
                        name="email1"
                        type="text"
                        maxLength="60"
                        label="Email (Additional)"
                        onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Email1')}
                        customError={displayCustomError('EMAIL1', this.props.fieldError_Email1)}
                        validate={validateEmail1}
                        component={renderTextField} />
                    </div>                    
                  </div>                 
                  <div className="col-sm-4">
                    <Field
                      name="userName1"
                      type="text"
                      maxLength="60"
                      autoComplete='email'
                      disabled={this.props.patientId && this.props.editUsernamePermission === false  ? true : false}                      
                      onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Username1')}
                      customError={displayCustomError('USERNAME1', this.props.fieldError_Username1)}
                      normalize={isValidName}
                      label="User Name (Additional)"
                      component={renderTextField} />
                  </div>                      
              </div> 

              {(this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === FUTURES) ?
              <div className="row">
                <div className="col-sm-4 require">
                    <Field
                      name="supportCoordinator"
                      type="text"
                      maxLength='50'
                      label="Support Coordinator" 
                      validate={validateSupportCoordinator}                                      
                      component={renderTextField} />
                </div>
               </div>  : null}    

               {(this.props.agencyName.toUpperCase().startsWith(EBS)) ?
                <div className="row">
                  <div className="col-sm-4">
                      <Field
                        name="serviceCoordinator"
                        type="text"
                        maxLength="100"
                        label="Service Coordinator"                     
                        component={renderTextField} />
                  </div>
                  <div className="col-sm-4">
                      <Field
                        name="eiNumber"
                        type="text"
                        maxLength="50"
                        label="EI #"                                                      
                        component={renderTextField} />
                  </div>                 
                  <div className="col-sm-4">
                      <Field
                        name="cfcNumber"
                        type="text"
                        maxLength="2"
                        label="CFC #"                                                      
                        component={renderTextField} />
                  </div>  
               </div>  : null}    


              {(this.props.agencyName.toUpperCase() === TFABA) ?
              <div className="row">               
                <div className="col-sm-4">
                    <Field
                      name="targetCaseManager"
                      type="text"
                      maxLength="100"
                      label="Target Case Manager"                                                        
                      component={renderTextField} />
                </div>                
               </div>  : null}        

                <div className="row">               
                  <div className="col-sm-4">
                      <Field
                        name="advanceCreditAmount"
                        type="text"
                        maxLength="8"
                        label="Advance Credit Amount($)"                                                        
                        component={renderTextField}
                        normalize={normalizeDecimal} />                      
                  </div>                
                </div>   
                {this.state.isPortalRequired ?
                <div className="row">     
                 { this.state.isDataCollectionEnabledForAgency ?   
                    <div className="col-sm-4">
                      <Field
                        className="mt-35 mb0 rend-check"
                        name="isViewDataCollectionGraphs"
                        label="View Data Collection Graphs"
                        component={renderCheckBox}                      
                      />
                    </div> : null}
                  <div className="col-sm-4">
                    <Field
                      className="mt-35 mb0 rend-check"
                      name="isViewClientDocuments"
                      label="View Client Documents"
                      component={renderCheckBox}                      
                    />
                  </div>
                  <div className="col-sm-4">
                    <Field
                      className="mt-35 mb0 rend-check"
                      name="isUploadClientDocuments"
                      label="Upload Client Documents"
                      component={renderCheckBox}                      
                    />
                  </div>
                </div>  : null}        
            </div>
          </div>

          <div className="readmin-panel mt-30">
            <div className="panel-body">
              <div>
                {/* therpay with rendering provider */}
                {(this.props.agencyName.toUpperCase() === FUTURES) ?
                  <FieldArray name="patientRenderingProviders" component={this.renderTherapiesDiagnosisYear} />
                  : <FieldArray name="patientRenderingProviders" component={this.renderTherapies} />}
              </div>              
            </div>
          </div>

          {
            !this.state.patientId ?
              <div className="readmin-panel mt-30">
                <div className="panel-body">
                  <div className="row">
                    <div className="col-sm-12 pt20 btn_rt">
                      <CommonButton type="submit" primary={true} disabled={this.props.loading ? true : false} label={`${this.props.loading ? 'Loading' : 'Save'}`} />
                    </div>
                  </div>
                </div>
              </div>
              : ''
          }

          {
            this.state.patientId ?
              <div className="readmin-panel mt-30">
                <div className="panel-body">
                  <div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="panel_title no_margin">
                          <h3>Emergency Contact</h3>
                          <i className="flaticon flaticon-technology"></i>
                        </div>
                        <div className="row">
                          <div className="col-sm-6 mt-35">
                            <Field
                              name="emergencyContactRelationship"
                              label="Relationship"
                              handleNewRequest={this.handleNewRequest}
                              options={this.state.masterRelationship}
                              component={renderAutoCompleteSingleSelect} />
                          </div>
                          {relationshipTypeObj && relationshipTypeObj.value && relationshipTypeObj.value.toUpperCase() === 'OTHER' ?
                            <div className='col-sm-6 require'>
                              <Field
                                name="emergencyContactOthers"
                                label="Other Relationship"
                                component={renderTextField}
                              />
                            </div>
                            : ''}
                        </div>
                        <div className='row'>
                          <div className="col-sm-4">
                            <Field
                              name="emergencyContactFirstName"
                              type="text"
                              maxLength="40"
                              normalize={isValidNameWithSpace}
                              label="First Name"
                              component={renderTextField} />
                          </div>
                          <div className="col-sm-4">
                            <Field
                              name="emergencyContactLastName"
                              type="text"
                              maxLength="40"
                              normalize={isValidNameWithSpace}
                              label="Last Name"
                              component={renderTextField} />
                          </div>
                          <div className="col-sm-4">
                            <Field
                              name="emergencyContactPhone"
                              type="text"
                              maxLength="14"
                              label="Phone Number"
                              component={renderTextField}
                              normalize={normalizeMobile} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="panel_title">
                        <h3>Tags</h3>
                        <i className="flaticon flaticon-commerce"></i>
                      </div>

                    </div>
                    <div className="col-sm-8 mt-35">
                      <Field
                        name="tag"
                        //multiple={true}
                        label="Tags"
                        options={this.props.masterTags}
                        handleNewRequest={this.handleNewRequestTag}
                        component={renderAutoCompleteScheduling}
                        fullWidth={true}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="panel_title">
                        <h3>Notes</h3>
                        <i className="flaticon flaticon-interface-1"></i>
                      </div>

                    </div>
                    <div className="col-sm-12">
                      <Field
                        name="note"
                        type="text"
                        maxLength="1000"
                        // normalize = {isValidNameWithSpace}
                        label="Enter Notes"
                        component={renderTextArea} />
                      <small className="blackfont font12">{this.props.Note ? 1000 - this.props.Note.length : 1000} Characters remaining </small>
                    </div>
                  </div>
                  <div>
                    <div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="panel_title">
                            <h3>Client Profile Photo</h3>
                            <i className="flaticon flaticon-picture"></i>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6 col-md-3">
                          <div className="uplaod_pic">
                            <FlatButton
                              label="Upload"
                              className="browse"
                              labelPosition="before"
                              style={styles.uploadButton}
                              containerElement="label"
                              fullWidth={true}>
                              <i className="fa fa-cloud-upload fa-2x" aria-hidden="true"></i>
                              <Field
                                name="PhotoBase64"
                                type="file"
                                style={styles.uploadInput}
                                component={renderUploadField}
                                onChange={(e) => this._handleImageChange(e)}
                                label="Client Photo" />
                            </FlatButton>
                            <small>{this.state.file ? this.state.file.name : ''}
                              {this.state.validImageError ? this.state.validImageError : ''}</small>
                          </div>
                          <p className="ins_photo">(jpg, jpeg, bmp, png)</p>
                        </div>
                        <div className="col-sm-12 col-md-8">
                          <div>
                            {this.state.imagePreviewUrl ?
                              <div className="insimage">
                                <img title="Insurance front image" src={this.state.imagePreviewUrl} alt={this.state.imagePreviewUrl} />
                                <b onClick={(e) => this.handleRemoveImage(e, 'profile')} className="fa fa-times-circle valuefont" aria-hidden="true"></b>
                              </div>
                              :
                              ''
                            }
                          </div>
                        </div>
                      </div></div></div>
                  <div className="row">
                    <div className="col-sm-12 pt20 btn_rt">
                      {/* <CommonButton type="submit" primary={true} disabled={this.props.loading ? true : false} label={`${this.props.loading ? 'Loading' : 'Save'}`} /> */}
                      <CommonButton className="ml_15" disabled={this.props.loading ? true : false} onTouchTap={handleSubmit(this.handleSaveContinue.bind(this))} primary={true} label="Save & Continue" />
                    </div>
                  </div>
                </div>
              </div> : ''
          }
        </form>
      </div>
    );
  }
}
const selector = formValueSelector('AccountDetailsForm'); // <-- same as form name

function mapStateToProps(state) {
  // console.log('state.patient.patientData...............', state.patient.getPatientDetails);
  let initialValueData = {
    locationID: state.login.currentLocationId || null,
  };
  if (state.patient.getPatientDetails) {
    let patientData = state.patient.getPatientDetails.data;
    //let diagnosis = (patientData.patientDiagnosis || []).find((obj) => obj.isPrimary);
    let tags = (patientData.patientTags || []).map((obj) => obj.tagID);
    initialValueData = {
      ...patientData,
      //icdid: diagnosis && diagnosis.icdid,
      tag: tags,
     patientRenderingProviders: patientData.patientRenderingProviders && patientData.patientRenderingProviders.length ? patientData.patientRenderingProviders : [{}],
    };
  }
  else {
    initialValueData = {
      patientRenderingProviders: [{}],
    };
  }
  let fieldError_Username = null;
  let fieldError_Username1 = null;
  let fieldError_SSN = null;
  let fieldError_MRN = null;
  let fieldError_Email = null;
  let fieldError_Email1 = null;

  if (state.appConfig && state.appConfig.fieldError) {
    fieldError_Username = state.appConfig.fieldError.filter((obj, i) => obj.data === 'USERNAME');
    fieldError_SSN = state.appConfig.fieldError.filter((obj, i) => obj.data === 'SSN');
    fieldError_MRN = state.appConfig.fieldError.filter((obj, i) => obj.data === 'MRN');
    fieldError_Email = state.appConfig.fieldError.filter((obj, i) => obj.data === 'EMAIL');
    fieldError_Email1 = state.appConfig.fieldError.filter((obj, i) => obj.data === 'EMAIL1');
    fieldError_Username1 = state.appConfig.fieldError.filter((obj, i) => obj.data === 'USERNAME1');
  }

  // Start For Role Permission
  let userScreenPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    //userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
  let changeClientLocation = hasDefaultAccess ? true : userScreenPermission ? userScreenPermission.filter((obj) => obj.screenKey === 'CLIENT_CHANGE_CLIENT_LOCATION_BEFORE_SCHEDULING_APPOINTMENT')[0].permission : false;
  let editUsernamePermission = hasDefaultAccess ? true : userScreenPermission && userScreenPermission.filter((obj) => obj.screenKey === 'CLIENT_EDIT_CLIENT_USERNAME')[0] ? userScreenPermission.filter((obj) => obj.screenKey === 'CLIENT_EDIT_CLIENT_USERNAME')[0].permission : false;

  // End For Role Permission

  return {
    RenderingProviders: state.patient.patientMasterData && state.patient.patientMasterData.masterRenderingProviderIncludingInactive ? state.patient.patientMasterData.masterRenderingProviderIncludingInactive : [],
    masterTherapy: state.patient.patientMasterData && state.patient.patientMasterData.masterTherapy ? state.patient.patientMasterData.masterTherapy : [],
    saved_patientDetails: state.patient.saved_patientDetails,
    getPatientDetails: state.patient.getPatientDetails,
    patientInfo: state.patient.patientInfo,
    patientPrimaryDiagnosis: state.patient.patientPrimaryDiagnosis,
    isUserNew: state.patient.isUserNew,
    patientMasterData: state.patient.patientMasterData,
    initialValues: initialValueData,
    patientPreference: state.patient.patientPreference,
    patientTags: state.patient.patientTags,
    loading: state.patient.loading,
    dob: selector(state, 'dob'),
    Tag: selector(state, 'tag'),
    isOtherCommunication: selector(state, 'isOtherCommunication'),
    // masterTags: state.patient.patientMasterTags,
    masterTags: state.patient.patientMasterData && state.patient.patientMasterData.masterTagsforPatient ? state.patient.patientMasterData.masterTagsforPatient : [],
    Note: selector(state, 'note'),
    currentLocationId: state.login.currentLocationId,
    loginUserInfo: state.login.loginUserInfo,
    userLocationList: state.login.userLocationList,
    EmergencyContactRelationship: selector(state, 'emergencyContactRelationship'),
    fieldError_Username: fieldError_Username,
    fieldError_SSN: fieldError_SSN,
    fieldError_MRN: fieldError_MRN,
    fieldError_Email: fieldError_Email,
    fieldError_Email1: fieldError_Email1,
    fieldError_Username1: fieldError_Username1,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    changeClientLocation: changeClientLocation,
    selectorPatientRenderingProviders: selector(state, 'patientRenderingProviders'),
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    editUsernamePermission: editUsernamePermission,
    patientRenderingProviders: state.patient.getPatientDetails && state.patient.getPatientDetails.data && state.patient.getPatientDetails.data.patientRenderingProviders && state.patient.getPatientDetails.data.patientRenderingProviders.length ? state.patient.getPatientDetails.data.patientRenderingProviders : [{}],
  };

}

AccountDetails = reduxForm({
  form: 'AccountDetailsForm',
  validate,
  enableReinitialize: true,
})(AccountDetails);
export default connect(mapStateToProps, { getPatientMasterData, getPatientMasterTags, savePatientDetails, savePatientTag, getPatientDetailsById, checkFieldExistence, clearFieldErrorArray, getPatientProfileDetails })(AccountDetails);



// WEBPACK FOOTER //
// ./src/modules/patients/account_details.js